import {Component, ElementRef, HostBinding, HostListener, OnInit, Renderer2} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {OptionService} from './shared/services/option/option.service';
import {UserService} from './shared/services/user/user.service';
import {OPTION_TYPE} from "./shared/defines/client.const";
import {SetHtmlLargeMode} from "./shared/defines/client.func";
import {first, Observable} from "rxjs";
import {filter} from "rxjs/operators";
import {TfSpiceService} from "./shared/services/tf-service/tf-spice.service";
import {GlobalEventService} from "./shared/services/global-event/global-event.service";
import {SeoService, SeoSummaryContent} from "./shared/services/seo/seo.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public readonly seoSummary$: Observable<SeoSummaryContent | null>;

  @HostBinding('attr.class') get cssClass(): string {
    return 'seungjo' + (this.option.seungjoDispType + 1);
  }

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private option: OptionService,
    private userSvc: UserService,
    private spiceSvc: TfSpiceService,   // 주의: 사용 안 한다고 지우면 안 됨. 여기서 선언하면 자동으로 생성되면서 TF SPICE를 다운받고 초기화 한다.
                                        // 사용할 때 로딩하고 초기화 하면 너무 느려져서, 미리 로딩하고 초기화 해 놓는다.
    private globalEventSvc: GlobalEventService,
    private router: Router,
    private seoSvc: SeoService,
  ) {
    this.seoSummary$ = this.seoSvc.currentSummary$;

    this.userSvc.Login().pipe(
      filter(value => value === true),
      first(),
    ).subscribe(flag => console.log('user login success', flag));
  }

  ngOnInit(): void {
    // 최초 진입 시 큰글씨 모드 처리
    if (this.option.largeMode) {
      SetHtmlLargeMode(this.renderer, this.el, true);
    }

    if (this.seoSvc.isComponentManaged(this.router.url)) {
      this.seoSvc.clearSummaryUntilDynamicUpdate();
    } else {
      this.seoSvc.updateByUrl(this.router.url);
    }
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ).subscribe(event => {
      if (this.seoSvc.isComponentManaged(event.urlAfterRedirects)) {
        this.seoSvc.clearSummaryUntilDynamicUpdate();
        return;
      }
      this.seoSvc.updateByUrl(event.urlAfterRedirects);
    });
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    // console.warn('AppComponent.onClick', $event);
    this.globalEventSvc.Click($event);
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey && (event.key === 'c' || event.key === 'C')) {
      event.preventDefault();
      alert('Copying is disabled.');
    }
  }
}
